export default "__VITE_ASSET__BZ$3aW8e__"